import {NgModule} from "@angular/core";
import {ReactiveFormsModule} from "@angular/forms";
import {questionnaireComponent} from "./questionnaire.component";
import {CommonModule} from "@angular/common";

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule
  ],
  exports: [
    questionnaireComponent
  ],
  declarations: [questionnaireComponent]
})
export class questionnaireMmodule {
}
